import React, { useMemo } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useNavigate } from 'react-router-dom';
import { LABEL } from '@veriables';
import { TouchableButton } from '@components/common/Touchable';
import styles from './SendOrderMode.module.scss';
import { sendAllItems, deleteAllItems } from '../CartActionHandler';

const SendOrderMode = ({
  deviceInfo,
  serverAppTheme,
  setShowSendOrderMode,
}) => {
  const navigate = useNavigate();
  const orderSendMode = !deviceInfo?.deviceGroup ? {} : deviceInfo?.deviceGroup?.orderSendModes;

  const options = [
    {
      key: 'toGo',
      label: LABEL().TOGO,
      isSuppoted: orderSendMode?.toGo,
      onClick: () => sendAllItems('toGo', navigate),
    },
    {
      key: 'onTheFly',
      label: LABEL().ON_THE_FLY,
      isSuppoted: orderSendMode?.rush,
      onClick: () => sendAllItems("onTheFly", navigate),
    },
    {
      key: 'doNotMake',
      label: LABEL().DO_NOT_MAKE,
      isSuppoted: orderSendMode?.doNoMake,
      onClick: () => sendAllItems("doNotMake", navigate),
    },
  ];
  const sendOrderModeInline = useMemo(() => {
    const optionsStyles = {
      height: '32px',
      background: serverAppTheme?.primaryBtn,
      color: serverAppTheme?.btn_font_color,
    };
    return { optionsStyles };
  }, [serverAppTheme]);
  return (
    <div
      id="sendOrderModeDiv"
      className={cn('position-absolute ', styles.sendOrderDivOrder)}
    >
      <div className='col-12 p-1 rounded-top rounded-left h-auto' style={{backgroundColor: serverAppTheme?.sendOrderModeBg}}>
      {options.map((option, i) => {
        return option.isSuppoted ? (
          <TouchableButton
            key={option.key}
            onClick={() => {
              option.onClick();
              setShowSendOrderMode(false);
            }}
            className={cn(
              'text-center mt-1 row mx-1 justify-content-center align-items-center rounded border-0',
              styles.sendOrderButtonDynamic,
              i === options.length - 1 && 'mb-1'
            )}
            style={sendOrderModeInline.optionsStyles}
          >
            {option.label}
          </TouchableButton>
        ) : <></>;
      })}
      </div>
      <div className="col-12 px-0 pl-3 d-flex flex-row-reverse">
          <div
            className="px-0 "
            style={{
              height: "10px",
              width: '41%',
              background: serverAppTheme?.sendOrderModeBg,
            }}
          ></div>
        </div>
    </div>
  );
};
const mapStateToProps = ({ oauth, theme }) => ({
  deviceInfo: oauth.deviceInformation,
  serverAppTheme: theme.serverAppTheme,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(SendOrderMode));
